const priceFormat = new Intl.NumberFormat('nl-NL', {
	minimumFractionDigits: 2,
	maximumFractionDigits: 2,
});

export const formatPrice = (number) => priceFormat.format(number);
